(function agreeCheckout() {
  document.addEventListener("DOMContentLoaded", function () {
    const agreeCheckbox = document.getElementById("agree-checkbox");
    const confirmCheckbox = document.getElementById("confirm-buy-now-checkbox");
    const checkoutButton = document.getElementById("checkout-button");

    let paymentButton = null;

    function updateButtonStates(source) {
      const checked =
        (source && source.checked !== undefined)
          ? source.checked
          : (agreeCheckbox?.checked || confirmCheckbox?.checked || false);
    console.log(source)
     
      if (checkoutButton) {
        checkoutButton.disabled = !checked;
      }

      if (agreeCheckbox && source !== agreeCheckbox) {
        agreeCheckbox.checked = checked;
      }

      if (confirmCheckbox && source !== confirmCheckbox) {
        confirmCheckbox.checked = checked;
      }
    }

    // Bind checkbox change event
    if (agreeCheckbox) {
      agreeCheckbox.addEventListener("change", () => updateButtonStates(agreeCheckbox));
    }
    if (confirmCheckbox) {
      confirmCheckbox.addEventListener("change", () => updateButtonStates(confirmCheckbox));
    }

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    // Initialization status
    updateButtonStates();
  });
})();